import { render } from "./list-of-banks.vue?vue&type=template&id=eec3009a&scoped=true"
import script from "./list-of-banks.vue?vue&type=script&lang=js"
export * from "./list-of-banks.vue?vue&type=script&lang=js"

import "./list-of-banks.vue?vue&type=style&index=0&id=eec3009a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eec3009a"]])

export default __exports__